module.exports = __webpack_public_path__ + "img/aq.f72a0cb9.png";